import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.ProfileSettingWelcomeCollectProfile,
  {
    key: LocationVarKey.ProfileSettingWelcomeMessage,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeCollectionMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeContactMethod,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeWantShortProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeWantSecondaryOptional,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1"),
      IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeWantShortProfile, "1")
    ])
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeWantConfirmProfile,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  },
  {
    key: LocationVarKey.ProfileSettingWelcomeWantCollectPersona,
    hideIf: IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader
        {...page}
        subheading="For first time users, require customers to provide their contact information before they can chat with the bot or a human."
      >
        {" "}
        Welcome
      </PageHeader>

      <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeCollectProfile} label="Collect Profile" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeCollectProfile, "1")}>
        <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ProfileSettingWelcomeMessage} />
        <DropdownRow
          {...page}
          marginTop
          label=" Collection Method"
          keyName={LocationVarKey.ProfileSettingWelcomeCollectionMethod}
          options={[
            {
              label: "Conversational",
              value: "Conversational"
            },
            {
              label: "Info Collect Card",
              value: "Card"
            }
          ]}
        />
        <DropdownRow
          {...page}
          marginTop
          label=" Preferred Contact Method"
          keyName={LocationVarKey.ProfileSettingWelcomeContactMethod}
          options={[
            {
              label: "Phone Number",
              value: "Phone"
            },
            {
              label: "Email",
              value: "Email"
            }
          ]}
        />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeWantShortProfile} label="Short Profile" />
        <Indent {...page}>
          <SwitchRow
            {...page}
            keyName={LocationVarKey.ProfileSettingWelcomeWantSecondaryOptional}
            hideIf={IS_NOT_EQUAL(LocationVarKey.ProfileSettingWelcomeWantShortProfile, "1")}
            label="Make Secondary Contact Method Optional"
          />
        </Indent>
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeWantConfirmProfile} label="Confirm Profile" />
        <SwitchRow {...page} keyName={LocationVarKey.ProfileSettingWelcomeWantCollectPersona} label="Collect Persona" />
      </Section>
    </>
  );
}
